import BaseEntity from "../core/entity/BaseEntity";
import type Level from "./Level";
import GameFlowManager from "./util/GameFlowManager";

/**
 * Base class for entities that exist within a run context.
 * Provides convenient access to the GameFlowManager.
 */
export abstract class RunEntity extends BaseEntity {
  /**
   * Gets the current GameFlowManager instance, if one exists.
   */
  getGameFlowManager(): GameFlowManager | undefined {
    const gameFlowManager = this.game?.entities.getById("gameFlowManager");
    if (!gameFlowManager) {
      return undefined;
    }
    return gameFlowManager as GameFlowManager;
  }
}

/**
 * Base class for entities that exist within a level context.
 * Provides convenient access to the current level.
 */
export abstract class LevelEntity extends RunEntity {
  /**
   * Gets the current level instance, if one exists.
   * @returns The current level or undefined if no level is active
   */
  getCurrentLevel(): Level | undefined {
    const level = this.game?.entities.getById("currentLevel");
    if (!level) {
      return undefined;
    }
    return level as Level;
  }
}
